// Anmeldeseite. Eine Flaeche, die es in der Original-App nicht gibt.

import { useSearchParams } from "react-router-dom";
import { Hinweis, Karte, Rahmen } from "../bausteine/Bausteine.js";

// Was der Ruecksprung von Google mitbringen kann. Der Server haengt es als
// ?anmeldung= an, damit die Seite nach einem Fehlschlag etwas sagen kann und
// nicht bloss wieder leer dasteht.
const MELDUNGEN: Record<string, string> = {
  abgebrochen: "Die Anmeldung wurde abgebrochen.",
  abgelaufen: "Der Anmeldeversuch ist abgelaufen. Bitte noch einmal.",
  gesperrt: "Dieses Konto ist gesperrt.",
  fehlgeschlagen: "Die Anmeldung hat nicht geklappt. Bitte noch einmal.",
};

export function Anmelden() {
  const [parameter] = useSearchParams();
  const meldung = MELDUNGEN[parameter.get("anmeldung") ?? ""];

  return (
    <Rahmen
      kinder={
        <Karte
          kinder={
            <>
              {meldung && <Hinweis art="fehler" kinder={meldung} />}
              <h2 className="mb-1 text-base font-medium">Anmelden</h2>
              <p className="mb-4 text-sm text-neutral-600">
                Kennzeichensammler ist eine private Instanz. Die Anmeldung läuft über Google, ein
                Passwort gibt es nicht.
              </p>
              {/* Ein Link und kein fetch: Der Server antwortet mit einer
                  Weiterleitung zu Google, und die muss der Browser selbst
                  gehen. */}
              <a
                href="/api/auth/google"
                className="inline-flex min-h-11 items-center rounded bg-akzent px-4 py-2 text-sm font-medium text-white transition hover:bg-akzent-dunkel"
              >
                Mit Google anmelden
              </a>
            </>
          }
        />
      }
    />
  );
}
